<app-gis-data-table (pageChange)="onPageChange($event)" [data]="dataSource" [columns]="displayedColumns"
  [totalCount]="totalCount" (toggleStatus)="updateApiLogStatus($event)">
</app-gis-data-table>
<!-- Loading indicator -->
<ngx-loading [show]="loader" [config]="{ backdropBackgroundColour: 'rgba(255,255,255,0.3)' }"></ngx-loading>
